import React, { useState, useEffect, useCallback } from "react";
import "./qualitative.css";
import Table from "../../table";
import { useAuth } from "../../../context/auth-context";
import { useAsync } from "../../../utils/use-async";
import { client } from "../../../utils/api-client";
import { Button, Form, Input, Popconfirm, message } from "antd";
import { useParams, useHistory } from "react-router-dom";
import TaskList from "../qualitative-task-list";
import EditList from "../qualitative-edit";
import exportFromJSON from 'export-from-json'
const moment = require("moment-timezone");

const ApprovedQualitative = () => {
  const { run, isLoading, data, isError, error } = useAsync();
  const [usersLoading, setUsersLoading] = useState(false);
  const [records, setRecords] = useState([]);
  const [taskModal, setTaskModal] = useState(false);
  const [taskList, setTaskList] = useState([]);

  const columns = [
    {
      title: "Effective Date",
      dataIndex: "effectiveDate",
      key: "effectiveDate",
      width: 100,
      sorter: true,
      ellipsis: true,
      render: (record) => <>{record.split("T")[0]}</>,
    },
    {
      title: "Approval Status",
      width: 100,
      sorter: true,
      ellipsis: true,
      render: (record) => (
        <>
          {record.managerApproval.toString() === "false"
            ? "Pending"
            : "Approved"}
        </>
      ),
    },
    //added by ayush
    {
      title: "Total Time",
      dataIndex: "totalHours",
      key: "totalHours",

      width: 100,
      sorter: true,
      ellipsis: true,
      render: (record) => (
        <>
          <div style={{ whiteSpace: "pre-wrap" }}>{record}</div>
        </>
      ),
    },
    // added by Ayush
    {
      title: "Manager Remarks",
      dataIndex: "managerRemark",
      key: "managerRemark",

      width: 200,
      sorter: true,
      ellipsis: true,
      render: (record) => (
        <>
          <div style={{ whiteSpace: "pre-wrap" }}>{record}</div>
        </>
      ),
    },
    {
      title: "User",
      width: 100,
      sorter: true,
      ellipsis: true,
      render: (record) => <>{record?.addedBy?.email}</>,
    },
    {
      title: "Actions",
      width: 150,
      ellipsis: true,
      render: (record) => (
        <>
          <Button
            type="link"
            onClick={() => {
              setTaskModal(true);
              setTaskList(record?.taskList);
            }}
          >
            View Task List
          </Button>
        </>
      ),
    },
  ];

  const fetchRecords = useCallback(() => {
    run(client("qualitative/all/approved/task")).then((res) => {
      setUsersLoading(true);
    });
  }, [run]);

  useEffect(() => {
    if (data?.message === "Fetched Qualiatative Task") {
      setRecords(transformTableData(data?.qualitativeRecords));
      setUsersLoading(false);
    }
  }, [data]);

  useEffect(() => {
    if (isError) {
      message.error(error.message);
    }
  }, [error]);

  useEffect(() => {
    fetchRecords();
  }, [taskModal]);

  const transformTableData = (data) =>
    data.map((user, index) => {
      let { ...rest } = user;

      return {
        key: index,
        ...rest,
        sr: index + 1,
      };
    });
    const handlePrint = () => {
      const fileName = "Qualitative_Task_Approved"
      const exportType = "xls"
      const dataToExport = data.qualitativeRecords.map(record => {
        const tasksFormatted = record.taskList.map(task => {
          return `${task.title} (${task.timeSpent.hours}h ${task.timeSpent.minutes}m)`;
        }).join(', ');
    
        return {
          'Effective Date': new Date(record.effectiveDate).toLocaleDateString(),
          'Approval Status': record.managerApproval ? 'Approved' : 'Pending',
          'Total Time': record.totalHours,
          'User': record.addedBy.email,
          'Task Details': tasksFormatted
        };
      });
      console.log(data.qualitativeRecords)
      exportFromJSON({ data: dataToExport, fileName, exportType })
    }
  return (
    <div className="manage--wrapper">
      <div
        style={{
          margin: "1rem 0rem",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <h1 style={{ marginBottom: 0 }}>All Approved Qualitative Projects</h1>
        <Button onClick={handlePrint}> Download Approved Record</Button>

        {/* <div>
          <Button onClick={() => setModal(true)} >Add Task</Button>
        </div> */}
      </div>
      <Table
        loading={usersLoading}
        data={records}
        columns={columns}
        size="middle"
      />
      <TaskList modal={taskModal} setModal={setTaskModal} records={taskList} />
    </div>
  );
};

export default ApprovedQualitative;
